export default __webpack_public_path__ + "static/media/language1.d814551b.png";